import { PLACEHOLDER } from './placeholders';
import { AUTH_USER_PASSWORD } from './constants';

/**
 * BUILD HEADER LINES
 * Every client sends the same Faraday headers, but each config format writes
 * them differently, so the indentation and the separator are caller supplied.
 *
 * @param {string} authMethod - AUTH_TOKEN or AUTH_USER_PASSWORD
 * @param {string} indent - whitespace prefixed to each line
 * @param {string} separator - what sits between the header name and its value
 * @return {string} the header lines joined by newlines, without a trailing comma
 */
const buildHeaderLines = (authMethod, indent, separator) => {
  const credentials = authMethod === AUTH_USER_PASSWORD
    ? [
      `"X-Faraday-Username"${separator}"${PLACEHOLDER.username}"`,
      `"X-Faraday-Password"${separator}"${PLACEHOLDER.password}"`
      ]
    : [`"X-Faraday-Token"${separator}"${PLACEHOLDER.apiToken}"`];

  return [`"X-Faraday-URL"${separator}"${PLACEHOLDER.instanceUrl}"`, ...credentials]
    .map((line, index, lines) => `${indent}${line}${index < lines.length - 1 ? ',' : ''}`)
    .join('\n');
};

export default buildHeaderLines;
